// extracted by mini-css-extract-plugin
module.exports = {"deactivated":"Deactivated_deactivated__1vgOL","content":"Deactivated_content__1t0fV","bold":"Deactivated_bold__2VDX7","avatar":"Deactivated_avatar__3rySd"};